import { BASE_ROUTE } from "@/config";
import axios from "axios";
export var Service = axios.create({
    baseURL: BASE_ROUTE,
    //   timeout: 5000, //延迟时间
    // method: "POST",
    //   headers: {
    //     "content-Type": "application/x-www-form-urlencoded",
    //     "pc-token": "4a82b23dbbf3b23fd8aa291076e660ec", //后端提供
    //   },
});
// 请求拦截
Service.interceptors.request.use(function (config) {
    // 无code或type
    if (config.method === "post" && Object.values(config.data).length < 2) {
        return Promise.reject(new Error());
    }
    else {
        return config;
    }
}, function (err) {
    // 在请求错误时要做的事儿
    // 该返回的数据则是axios.catch(err)中接收的数据
    return Promise.reject(err);
});
// 响应拦截
Service.interceptors.response.use(function (response) {
    return response.data;
}, function (err) {
    // console.log(err);
});
